module.exports = __webpack_public_path__ + "img/LUB00401.cad10fc0.png";